var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountainBase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5285 23.8857C24.1471 23.8857 22.8224 23.3369 21.8456 22.3602C20.8689 21.3834 20.3201 20.0587 20.3201 18.6773C20.3201 17.296 20.8689 15.9712 21.8456 14.9945C22.8224 14.0177 24.1471 13.469 25.5285 13.469C26.9098 13.469 28.2346 14.0177 29.2113 14.9945C30.1881 15.9712 30.7368 17.296 30.7368 18.6773C30.7368 19.3613 30.6021 20.0386 30.3403 20.6705C30.0786 21.3024 29.695 21.8765 29.2113 22.3602C28.7277 22.8438 28.1535 23.2275 27.5216 23.4892C26.8897 23.7509 26.2124 23.8857 25.5285 23.8857ZM25.5285 4.09399C21.6607 4.09399 17.9514 5.63045 15.2165 8.36535C12.4816 11.1003 10.9451 14.8096 10.9451 18.6773C10.9451 29.6148 25.5285 45.7607 25.5285 45.7607C25.5285 45.7607 40.1118 29.6148 40.1118 18.6773C40.1118 14.8096 38.5753 11.1003 35.8404 8.36535C33.1055 5.63045 29.3962 4.09399 25.5285 4.09399Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountainBase);
export default __webpack_public_path__ + "static/media/mountain_base.1fc61b1d0b0319fac81a9fd4df52e9c1.svg";
export { ForwardRef as ReactComponent };